
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32","fill":"none","stroke":"#000","stroke-linejoin":"round","stroke-miterlimit":"10"}},[_c('path',{attrs:{"d":"M21.5 27l-11-11 11-11"}})])
      }
    
      }
    